module.exports = __webpack_public_path__ + "static/media/IM.0c0bbf51.jpg";